import React, { useEffect, useRef, useState } from 'react';
import { Menu } from 'react-feather';
import { useQuery } from '@apollo/react-hooks';
import { Link } from '@reach/router';
import { APPS, getUrl } from '@squirrellearningltd/go-shared-utils';
import BackLink from '../../components/BackLink';
import Tabs from '../../components/Tabs';
import Tab from '../../components/Tab';
import AddSpecialStore from './AddSpecialStore';
import { GET_SPECIAL_STORE_OPENINGS } from './services/graphql';
import styles from './BoomerItems.module.scss';
import categoryStyles from '../../components/ListCategory/ListCategories.module.scss';
import plusCircled from '../../images/plus-circled.svg';

const SpecialStores = ({ openingId }) => {
    const [openMenuId, setOpenMenuId] = useState(null);
    const menuRef = useRef(null);

    useEffect(() => {
        const closeMenu = event => {
            if (menuRef.current && !menuRef.current.contains(event.target)) setOpenMenuId(null);
        };
        const onKeyDown = event => {
            if (event.key === 'Escape') setOpenMenuId(null);
        };
        document.addEventListener('click', closeMenu);
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('click', closeMenu);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);

    const { data, loading, error } = useQuery(GET_SPECIAL_STORE_OPENINGS, { fetchPolicy: 'network-only' });
    const openings = ((data && data.specialStoreOpening) || []).map(opening => ({
        ...opening,
        avatarItems: (opening.avatarItems || []).map(item => {
            const url = (item.photoUrls && item.photoUrls[0]) || (item.url && item.url[0]) || '';
            return {
                ...item,
                previewUrl: url && !/^(https?:)?\/\//.test(url) && !url.startsWith('data:') ?
                    `${getUrl(APPS.go_portal_pupil)}${url.startsWith('/') ? '' : '/'}${url}` : url,
            };
        }),
    }));

    if (openingId) {
        if (loading) return <p>Loading special store...</p>;
        if (error) return <p role='alert'>{error.message}</p>;
        const opening = openings.find(store => store.id === decodeURIComponent(openingId));
        return opening ? <AddSpecialStore key={opening.id} opening={opening} /> : (
            <><BackLink to='/boomerItems/specialStore' text='Back to Drafts' /><p>Special store not found.</p></>
        );
    }

    return (
        <>
            <BackLink to='/boomerItems' text='Back' />
            <div className={styles.sectionHeader}>
                <h1 className={styles.headerTitle}>Overview/Boomer Items/Special Store</h1>
            </div>
            <Tabs className={styles.tabsContainer}><Tab selected>Drafts</Tab></Tabs>
            {loading ? <p>Loading special stores...</p> : error ? <p role='alert'>{error.message}</p> : (
                <div className={styles.itemsWrapper}>
                    <Link to='/boomerItems/specialStore/new' className={`${styles.itemCard} ${styles.addItemCard}`} aria-label='Create special store'>
                        <img className={styles.addItemIcon} src={plusCircled} alt='' />
                    </Link>
                    {openings.map(opening => (
                        <div className={`${styles.itemCard} dropdownHolder`} key={opening.id}>
                            <div className={categoryStyles.burgerMenuWrapper} ref={openMenuId === opening.id ? menuRef : null}>
                                <button type='button' className='dropdownMenuItem' aria-label={`Options for store starting ${opening.startDate}`} aria-expanded={openMenuId === opening.id} onClick={() => setOpenMenuId(openMenuId === opening.id ? null : opening.id)}>
                                    <Menu size='24' />
                                </button>
                                {openMenuId === opening.id && (
                                    <ul className='dropdownMenu dropdownMenuRight'>
                                        <li>
                                            <Link className='dropdownMenuItem' to={`/boomerItems/specialStore/${encodeURIComponent(opening.id)}/edit`} onClick={() => setOpenMenuId(null)}>Edit</Link>
                                        </li>
                                    </ul>
                                )}
                            </div>
                            <p className={styles.itemName}>Start Date: {opening.startDate}</p>
                            <p className={styles.itemName}>End Date: {opening.endDate}</p>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default SpecialStores;
